import { useAuth0 } from '@auth0/auth0-react'
import { SortOrder, useNetworksSlimLazyQuery } from '@generated/graphql'
import { defaultLanguageIdSelector } from '@store/slices/languages/selectors'
import { setNetworks, setNetworksLoading } from '@store/slices/networks'
import { useAppDispatch, useAppSelector } from '@store/typedHooks'
import { useCallback, useEffect } from 'react'

export function useFetchNetworks(refetchOnly: boolean = false) {
  const dispatch = useAppDispatch()
  const { isAuthenticated } = useAuth0()
  const defaultLanguageId = useAppSelector(defaultLanguageIdSelector)

  const [queryNetworks, { refetch }] = useNetworksSlimLazyQuery({
    notifyOnNetworkStatusChange: true,
    onCompleted: ({ networks }) => {
      dispatch(setNetworks(networks))
    },
    onError: error => {
      console.error('Unable to load networks', error)
    },
  })

  useEffect(() => {
    if (!isAuthenticated || !defaultLanguageId || refetchOnly) {
      return
    }
    dispatch(setNetworksLoading(true))
    queryNetworks({
      variables: { defaultLanguageId, orderBy: { createdAt: SortOrder.Asc } },
    })
  }, [isAuthenticated, queryNetworks, defaultLanguageId, refetchOnly, dispatch])

  const fetchNetworks = useCallback(async () => {
    dispatch(setNetworksLoading(true))
    await refetch({ defaultLanguageId, orderBy: { createdAt: SortOrder.Asc } })
  }, [dispatch, refetch, defaultLanguageId])

  if (refetchOnly) {
    return fetchNetworks
  }
}
